module.exports = __webpack_public_path__ + "static/MiniPies_Illustration-890c868c57293fba7db9857ad850a2b5.png";